import RAPIER from '@dimforge/rapier3d-compat';

import { App } from './app/App';
import { STRINGS } from './ui/strings.zh-HK';
import './ui/style.css';

function reportBootError(error: unknown): void {
  const message = error instanceof Error ? `${error.name}: ${error.message}` : String(error);
  console.error('[roll-ball-maze] boot failed', error);

  const element = document.getElementById('boot-error');
  if (element) {
    element.textContent = `${STRINGS.bootError}\n${message}`;
    element.style.display = 'block';
  }
}

async function bootstrap(): Promise<void> {
  const canvas = document.getElementById('game-canvas');
  const hudRoot = document.getElementById('hud');
  const displayRoot = document.getElementById('display');
  const debugRoot = document.getElementById('debug-view');

  if (!(canvas instanceof HTMLCanvasElement)) {
    throw new Error('index.html is missing <canvas id="game-canvas">');
  }
  if (!hudRoot) {
    throw new Error('index.html is missing <div id="hud">');
  }
  if (!displayRoot) {
    throw new Error('index.html is missing <div id="display">');
  }
  if (!debugRoot) {
    throw new Error('index.html is missing <div id="debug-view">');
  }

  // The `-compat` build inlines its WASM, so there is no separate .wasm asset to
  // serve - but the module still has to be initialised exactly once, before any
  // RAPIER.World is constructed.
  await RAPIER.init();

  const app = new App({ canvas, hud: hudRoot, display: displayRoot, debugView: debugRoot });

  // Load the production models BEFORE the simulation starts, so the board is
  // never briefly the fallback and then swapped. A failed load is reported
  // loudly rather than papered over.
  await app.load();

  const report = app.assetReport();
  if (!report.ok) {
    const messages = report.assets
      .filter((asset) => asset.status !== 'loaded' || asset.usedFallback)
      .map((asset) => `${asset.path || asset.name} — ${asset.error ?? 'unavailable'}`);
    console.error('[roll-ball-maze] asset integration incomplete', messages);
    app.showAssetFailure(messages);
  }

  app.start();
}

void bootstrap().catch(reportBootError);
